<div class="modal-header">
  <button
    type="button"
    class="btn-close"
    (click)="bsModalRef.hide()"
    aria-label="Close"
  >
    <i class="feather x"></i>
  </button>
  <h4 class="modal-title" id="myModalLabel">Google account configuration</h4>
</div>
<div class="modal-body" style="background: #fff; padding-bottom: 0">
  @if (loading) {
<div class="loading" style="border-radius: 16px">
    <div class="loader">Loading...</div>
  </div>
}

  <div class="form-group">
    <label for="">Google email</label>
    <input
      type="text"
      class="form-control"
      placeholder="username@gmail.com"
      [(ngModel)]="email"
    />
  </div>
  <div class="form-group">
    <label for=""> Application password </label>
    <div class="input-password">
      <input
        id="inputPass01"
        type="password"
        class="form-control"
        placeholder="NOT your email password"
        [(ngModel)]="imapPassword"
      />
      <i class="feather eye-off"></i>
    </div>
    <p class="mt-3">
      <b>Important:</b> You need to
      <a
        href="https://clienthub.reamaze.com/articles/connecting-to-a-google-mail-account"
        target="_blank"
        rel="noreferrer noopener"
        >create an app password</a
      >
      to connect (this is different from your email account password).
    </p>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-primary-light" (click)="verifyLoginInformation()">
    Test settings
  </button>
  <button
    class="btn btn-primary"
    [disabled]="allowed == false"
    (click)="createAccount()"
  >
    Continue
  </button>
</div>
